export const pathBuilder = (path, trackingStatusRoute, id, queryString = undefined) => {
  if (queryString) {
    const string = Object.keys(queryString).map(key => `${key}=${queryString[key]}`).join('&')
    return path + trackingStatusRoute + `?${string}`; 
  } else {
    return path + trackingStatusRoute + `?id=${id}`;
  }
};

export const removeIdFromQueryString = (queryString) => {
  return Object.keys(queryString).map(key => {
    if (key !== 'id') {
      return `${key}=${queryString[key]}`
    } else {
      return ''
    }
  }).filter(value => value !== '').join('&');
}

export const regexFirstCharacter = (string, character) => {
  const regex = new RegExp("^" + character, "g");
  return string.match(regex);
};

const createPrefix = (amount) => {
  return amount < 0 ? "- $" : "$";
};

const getLastCharactersOfString = (str, count) => {
  const amountString = str.toString();
  return amountString.slice(amountString.length - count);
};

const sliceMoneySegment = (amount) => {
  const thousandthOfAmount = Math.floor(amount / 1000);
  if (thousandthOfAmount > 0) {
    const lastThreeDigits = getLastCharactersOfString(amount, 3);

    return sliceMoneySegment(thousandthOfAmount) + "," + lastThreeDigits;
  }
  return amount;
};

const defaultOptions = { removeZeroCents: true }

export const getCents = (amount, removeZeroCents = true) => {
  const formattedZeroCents = removeZeroCents ? "" : ".00";

  if (amount === undefined || isNaN(amount) || amount === null) {
    return "" || formattedZeroCents;
  }

  const amountString = amount.toString();
  const regex = /(\.\d{1,2})/g;
  let cents = amountString.match(regex);
  if (!cents) {
    cents = [formattedZeroCents];
  }
  if (((cents.toString()).split("")).length === 2) {
    cents = (cents.toString()) + "0";
  }

  return cents.toString();
};

export const formatMoney = (amount, options = {}) => {
  const optionsWithDefaults = { ...defaultOptions, ...options }
  const absoluteAmount = Math.abs(amount);
  const dollarAmount = Math.floor(absoluteAmount);
  return (
    createPrefix(amount) +
    sliceMoneySegment(dollarAmount) +
    getCents(absoluteAmount, optionsWithDefaults.removeZeroCents)
  );
};

